import React from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import Button from "@material-ui/core/Button";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import StopIcon from "@material-ui/icons/Stop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core";
import { Auth } from "aws-amplify";
import AWS from "aws-sdk";
import styles from "../../styles";
import { pushMessage } from "../../../../redux/actions/commonActions";
import { FAQ_CMS_REDUX_QUESTION_FORM_NAME } from "../../../../constants";
import { isString } from "../../../../common/utils";
import {getEnvironmentName} from "../../../../utils"
const environment = getEnvironmentName()
const config = require("../../../../app_configuration").CONFIGURATION[environment];

const NO_PLAYBACK = "NO_PLAYBACK";
const LOADING_AUDIO = "LOADING_AUDIO";
const PLAYING = "PLAYING";

class TextToSpeech extends React.Component {
  constructor(props) {
    super(props);

    this.polly = null;
    this.audio = null;
    this.state = {
      playbackState: NO_PLAYBACK
    };
  }

  componentDidMount = async () => {
    const credentials = await Auth.currentCredentials();
    AWS.config = new AWS.Config();
    AWS.config.accessKeyId = credentials.accessKeyId;
    AWS.config.secretAccessKey = credentials.secretAccessKey;
    AWS.config.sessionToken = credentials.sessionToken;
    AWS.config.region = config.AWS_REGION;
    this.polly = new AWS.Polly({ apiVersion: "2016-06-10" });
  };

  resetPlaybackState = () => {
    this.setState({ playbackState: NO_PLAYBACK });
  };

  pollySynthesizeSpeechCallback = (err, data) => {
    const { pushMessage } = this.props;
    const errorMsg = {
      message: "Can't play audio.",
      type: "error"
    };

    if (err) {
      pushMessage(errorMsg);
      this.resetPlaybackState();
      return;
    }

    this.audio = new Audio();
    const blob = new Blob([data.AudioStream.buffer], { type: "audio/mp3" });
    this.audio.src = URL.createObjectURL(blob);
    this.audio.addEventListener("ended", this.resetPlaybackState);
    this.setState({ playbackState: PLAYING });

    this.audio.play().catch(() => {
      pushMessage(errorMsg);
      this.resetPlaybackState();
    });
  };

  /**
   * NB this.props.textToSynthesize will never be an empty string in this function because the playback button will be
   * disabled in that case thanks to this.playbackButtonIsDisabled.
   */
  handlePlayButtonClick = () => {
    const { pushMessage, textToSynthesize } = this.props;

    if (!this.polly) {
      pushMessage({
        message: "The page is not ready yet. Please try again in a moment.",
        type: "warning"
      });
      return;
    }

    if (this.state.playbackState === PLAYING) {
      if (this.audio) {
        // Stop playback
        this.audio.pause();
        this.audio.currentTime = 0;
        this.resetPlaybackState();
      }
      return;
    }

    const speechParams = {
      OutputFormat: "mp3",
      Text: textToSynthesize,
      VoiceId: "Joanna",
      LanguageCode: "en-US",
      SampleRate: "16000",
      TextType: "text"
    };

    this.setState({ playbackState: LOADING_AUDIO });
    this.polly.synthesizeSpeech(speechParams, this.pollySynthesizeSpeechCallback);
  };

  renderPlaybackButtonContent = () => {
    const { textToSpeechIconInButton } = this.props.classes;
    const { playbackState } = this.state;

    switch (playbackState) {
      case LOADING_AUDIO:
        return (
          <React.Fragment>
            <CircularProgress className={textToSpeechIconInButton} size={16} /> Loading
          </React.Fragment>
        );
      case PLAYING:
        return (
          <React.Fragment>
            <StopIcon className={textToSpeechIconInButton} /> Stop
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            <PlayArrowIcon className={textToSpeechIconInButton} /> Listen
          </React.Fragment>
        );
    }
  };

  /**
   * The playback button is disabled if: a) the component is still loading audio OR b) audio is not playing and
   * this.props.textToSynthesize is invalid (if the audio is still playing, the button needs to be enabled so we can
   * stop it).
   */
  playbackButtonIsDisabled = () => {
    const { textToSynthesize } = this.props;
    const { playbackState } = this.state;
    const validText = isString(textToSynthesize) && textToSynthesize.trim().length;
    return playbackState === LOADING_AUDIO || (playbackState !== PLAYING && !validText);
  };

  render() {
    return (
      <Button
        color="secondary"
        variant="contained"
        size="small"
        className={this.props.classes.textToSpeechButton}
        onClick={this.handlePlayButtonClick}
        disabled={this.playbackButtonIsDisabled()}
      >
        {this.renderPlaybackButtonContent()}
      </Button>
    );
  }
}

const formSelector = formValueSelector(FAQ_CMS_REDUX_QUESTION_FORM_NAME);

const mapStateToProps = state => {
  return {
    textToSynthesize: formSelector(state, "voiceResponse")
  };
};

const mapDispatchToProps = { pushMessage };

TextToSpeech = connect(
  mapStateToProps,
  mapDispatchToProps
)(TextToSpeech);

export default withStyles(styles)(TextToSpeech);
